<template>
  <div class="relative h-full w-full">
    <div class="absolute h-full xl:h-[calc(100% - 67px)] pt-[68px] lg:block">
      <div class="sidebar-container sticky mt-0 pt-[68px] flex flex-col">
        <AtomHeadingContentItem :title="$t('recommendation.suggestion-page.find-my-concert-title')" class="inline-block w-full" text-color="text-app-primary-1-red--fire-brick" />
        <div class="sidebar-inner-container overflow-y-auto scrollbar mb-4 h-full">
          <div class="collapsable transform duration-500 hover:shadow-none">
            <section v-if="selectionPath.length">
              <ul v-for="(selection, index) of selectionPath" :key="index">
                <li v-if="getSelectionQuestion(selection[0]).group !== 'fragment'">
                  {{ locale === 'nl' ? getSelectionQuestion(selection[0]).content_nl : getSelectionQuestion(selection[0]).content_en }}
                </li>
                <li v-if="getSelectionQuestion(selection[0]).group !== 'fragment'">
                  {{ locale === 'nl' ? getSelectionAnswer(selection[1]).answer_nl : getSelectionAnswer(selection[1]).answer_en }}
                </li>
              </ul>
            </section>
          </div>
        </div>
        <MoleculeButton
          size="x-large"
          class="!font-normal mt-auto align-bottom md:flex group-hover:bg-app-primary-1-red--fire-brick group-focus:bg-app-primary-1-red--fire-brick z-10"
          @click="reset"
        >
          {{ $t('recommendation.suggestion-page.button-start-over') }}
        </MoleculeButton>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
const recommendationsStore = useRecommendationsStore()
const selectionPath = computed(() => recommendationsStore.selectionPath)
const selectionQuestions = computed(() => recommendationsStore.questions)
const selectionAnswers = computed(() => recommendationsStore.answers)

function getSelectionQuestion(questionId: string) {
  return selectionQuestions.value ? selectionQuestions.value[questionId] : null
}

function getSelectionAnswer(answerId: string) {
  return selectionAnswers.value ? selectionAnswers.value[answerId] : null
}

function reset() {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  recommendationsStore.reset()
}
</script>
<style scoped lang="scss">
.sidebar-container {
  @apply rounded-r-[20px] bg-white px-4 py-4 h-[calc(100vh-136px)] top-[136px];
}

.sidebar-inner-container {
  @apply px-4 py-2;
  box-shadow: inset 0px -14px 8px -10px rgba(0, 0, 0, 0.1);

  @screen lg {
    @apply rounded-l-none max-h-[calc(100vh*0.8)] overflow-x-hidden w-80;
  }
}

ul {
  @apply mb-6;

  & > li:first-child {
    @apply font-medium;
  }
}

.collapsable {
  transition-property: max-height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
}
</style>
